<ng-container *ngFor="let vehicles of day.cars">
  <div class="container mt-3" *ngFor="let vehicle of vehicles.vehicles"
    [id]="vehicle?.code ? 'svc-' + vehicle.code : null">
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <img class="img-fluid service-photo" [src]="vehicle.image" alt="Auto" [fallbackSrc]="defaultImage || noImageUrl"
          [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
      </div>

      <div class="col-xs-12 col-md-8">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <h5>
              <span class="text-capitalize">{{ vehicle.model | lowercase }}</span>
            </h5>
          </div>
          <div class="col-xs-12 col-md-4">
            <app-pnr [pnr]="vehicle?.pnr" [supplierName]="vehicle?.supplierName"></app-pnr>
          </div>
        </div>

        <div class="grouped-row">
          <div class="itinerary-contents">
            <div class="itinerary-content">
              <span class="itinerary-icons"><em class="fas fa-store"></em></span>
              <h6>
                <span class="text-capitalize">{{vehicle.vendor?.name | lowercase}}
                </span>
              </h6>
            </div>

            <div class="itinerary-content">
              <span class="itinerary-icons"><em class="fas fa-star"></em></span>
              <h6>
                <span class="text-capitalize">{{vehicle.carClass | lowercase}} <ng-container
                    *ngIf="vehicle.promotionDescription">+ {{vehicle.promotionDescription}}</ng-container></span>
              </h6>
            </div>

            <div class="itinerary-content">
              <span class="itinerary-icons">
                <em class="fas fa-arrow-right"></em>
              </span>
              <h6>
                <span class="text-capitalize">
                  <ng-container *ngIf="vehicle.type === 'CAMPER'; else carPickup">
                    {{vehicles.pickup?.date | localizedDate: "dd MMM"}}
                    -
                    {{ vehicle.locations?.pickup[0]?.name | lowercase }} {{ vehicle.locations?.pickup[0]?.address }}
                    <ng-container *ngIf="vehicle.locations?.pickup[0]?.cityName">({{
                      vehicle.locations?.pickup[0]?.cityName }})</ng-container>
                  </ng-container>
                  <ng-template #carPickup>
                    {{vehicles.pickup?.date + " " + vehicles.pickup?.hour
                    | localizedDate: "dd MMM, HH:mm"}}
                    -
                    {{ vehicle.locations?.pickup[0]?.name | lowercase }}
                  </ng-template>
                </span>
              </h6>
            </div>

            <div class="itinerary-content">
              <span class="itinerary-icons"><em class="fas fa-arrow-left"></em></span>
              <h6>
                <span class="text-capitalize">
                  <ng-container *ngIf="vehicle.type === 'CAMPER'; else carDropoff">
                    {{vehicles.dropoff?.date | localizedDate: "dd MMM"}}
                    -
                    {{ vehicle.locations?.dropoff[0]?.name | lowercase }} {{ vehicle.locations?.dropoff[0]?.address }}
                    <ng-container *ngIf="vehicle.locations?.dropoff[0]?.cityName">({{
                      vehicle.locations?.dropoff[0]?.cityName }})</ng-container>
                  </ng-container>
                  <ng-template #carDropoff>
                    {{vehicles.dropoff?.date + " " + vehicles.dropoff?.hour
                    | localizedDate: "dd MMM, HH:mm"}}
                    -
                    {{ vehicle.locations?.dropoff[0]?.name | lowercase }}
                  </ng-template>
                </span>
              </h6>
            </div>

            <!-- <ng-container *ngIf="vehicle.type !== 'CAMPER'">
              <ul class="mt-0 mb-2 text-default listing-vehicles-type" style="font-size: 12px;"
                *ngIf="vehicle?.comments">
                <ng-container *ngFor="let comment of vehicle.comments">
                  <li *ngIf="comment.value" class="mb-1">
                    <div class="li-inline-content">
                      <span [innerHTML]="comment.value | safeHtml"></span>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </ng-container> -->

            <p class="m-0 text-default" *ngIf="!replaceShowDescriptionButtonWithNotes && vehicles?.notes">
              <ng-container *ngFor="let item of vehicles?.notes">
                <ng-container *ngIf="state === 'Preventivo'">
                  <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
                    <span [innerHTML]="item.text | safeHtml"></span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="state === 'Confermata'">
                  <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
                    <span [innerHTML]="item.text | safeHtml"></span>
                  </ng-container>
                </ng-container>
              </ng-container>
            </p>
          </div>

          <app-vehicle-details [vehicle]="vehicle" [serviceIcons]="serviceIcons"></app-vehicle-details>
        </div>

      </div>

      <div class="itinerary-content pt-2 col-12">
        <ng-container *ngIf="replaceShowDescriptionButtonWithNotes; else vehicleDescriptionToggle">
          <ng-container *ngTemplateOutlet="vehicleExtraDetails"></ng-container>
          <span [innerHTML]="vehicle.description ? vehicle.description : formatData(vehicle.rules) | safeHtml"></span>
          <details class="details" *ngIf="getFilteredNotes(vehicles.notes).length > 0">
            <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
              attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
            </summary>
            <div class="row">
              <div class="col-12">
                <ng-container *ngFor="let item of getFilteredNotes(vehicles.notes)">
                  <span [innerHTML]="item.text | safeHtml"></span>
                </ng-container>
              </div>
            </div>
          </details>
        </ng-container>
        <ng-template #vehicleDescriptionToggle>
        <details class="details" open="true">
          <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
            attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
          </summary>
          <ng-container *ngTemplateOutlet="vehicleExtraDetails"></ng-container>
          <div class="row">
            <div class="col-12">
              <span
                [innerHTML]="vehicle.description ? vehicle.description : formatData(vehicle.rules) | safeHtml"></span>
            </div>
          </div>
        </details>
        </ng-template>
        <ng-template #vehicleExtraDetails>
          <div class="row">
            <div class="col-12">
              <!-- <ng-container *ngIf="vehicle.type === 'CAMPER'"> -->
              <!-- Sezione per comments -->
              <ng-container *ngIf="vehicle.comments && hasVisibleComments(vehicle.comments)">
                <h6 class="mt-3 mb-2"><strong>{{ "ITINERARY.VEHICLE.INCLUDED_IN_BASE_PRICE" | translate }}:</strong>
                </h6>
                <ul>
                  <ng-container *ngFor="let comment of vehicle.comments">
                    <li *ngIf="comment.value" class="mb-1">
                      <div class="li-inline-content">
                        <span [innerHTML]="comment.value | safeHtml"></span>
                      </div>
                    </li>
                  </ng-container>
                </ul> 
              </ng-container>

              <!-- Sezione per equipments inclusi nel prezzo (purchasableOnline = true) -->
              <ng-container *ngIf="vehicle.equipments && getIncludedEquipments(vehicle.equipments).length > 0">
                <h6 class="mt-3 mb-2"><strong>{{ "ITINERARY.VEHICLE.OTHER_EXTRAS_INCLUDED" | translate }}:</strong>
                </h6>
                <ul>
                  <li *ngFor="let equipment of getIncludedEquipments(vehicle.equipments)" class="mb-1">
                    <div class="li-inline-content">
                      <span class="fw-bold">{{equipment.quantity}}x</span>
                      <span [innerHTML]="equipment.description | safeHtml"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <!-- Sezione per equipments da pagare sul posto (purchasableOnline = false) -->
              <ng-container *ngIf="vehicle.equipments && getPayableEquipments(vehicle.equipments).length > 0">
                <h6 class="mt-3 mb-2"><strong>{{ "ITINERARY.VEHICLE.OTHER_EXTRAS_PAYABLE" | translate }}:</strong>
                </h6>
                <ul>
                  <li *ngFor="let equipment of getPayableEquipments(vehicle.equipments)" class="mb-1">
                    <div class="li-inline-content">
                      <span class="fw-bold">{{equipment.quantity}}x </span>
                      <span [innerHTML]="equipment.description | safeHtml"></span>
                      <span class="fw-bold"> - {{equipment.amountaftertax}} </span>
                      <span [innerHTML]="equipment.currency | safeHtml"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>
              <!-- </ng-container> -->

            </div>
          </div>
        </ng-template>
        <h6>

        </h6>
      </div>
    </div>

    <div class="col-12 mt-2 mb-2" *ngIf="showLineAfter(day)">
      <hr class="line-grey">
    </div>
  </div>
</ng-container>